import React from "react";
import logo from "./../Content/images/logo3.png";

/**
 * ErrorBoundary component that catches JavaScript errors in its child component tree.
 *
 * @component
 * @returns {React.ReactNode} The ErrorBoundary component or its children.
 */
class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  /**
   * Lifecycle method that catches JavaScript errors anywhere in the child component tree.
   *
   * @param {Error} error - The error that was thrown.
   * @param {object} info - An object with information about the component stack.
   */
  componentDidCatch(error, info) {
    this.setState({ hasError: true });
  }

  render() {
    if (this.state.hasError) {
      return (
        <div
          className="d-flex flex-column justify-content-center align-items-center"
          style={{ height: "80vh" }}
        >
          <img
            src={logo}
            alt="Logo"
            className="img-fluid"
            style={{ maxWidth: "200px" }}
          />
          <h1>Something went wrong.</h1>
          <div className="text-center">
            <p className="text-secondary font-italic">
              We have sent an incident report to our tech support.
            </p>
            <p className="text-secondary font-italic">
              Please contact{" "}
              <a href="mailto:connect@logisticsnow.in">
                connect@logisticsnow.in
              </a>{" "}
              for any assistance.
            </p>
          </div>
        </div>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
